import { unstickScrollFromBottom } from '@/helpers/scroll'

export function setCurrentSlideIndex(vm, index) {
  if (process.env.TARGET_ENV === 'development' && typeof vm.slideLength === 'undefined') {
    throw new Error(
      'The property "slideLength" is missing in vue model provided in "setCurrentSlideIndex"'
    )
  }
  if (index >= 0 && index < vm.slideLength) {
    unstickScrollFromBottom()
    vm.currentSlideIndex = index
  }
}

export function decreaseCurrentSlideIndex(vm) {
  setCurrentSlideIndex(vm, vm.currentSlideIndex - 1)
}

export function incrementCurrentSlideIndex(vm) {
  setCurrentSlideIndex(vm, vm.currentSlideIndex + 1)
}
